import { render, staticRenderFns } from "./GestionAteliers.vue?vue&type=template&id=3eb9ad60"
import script from "./GestionAteliers.vue?vue&type=script&lang=js"
export * from "./GestionAteliers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports